import { isEmpty } from 'lodash';
import nanoid from 'nanoid';

const layoutReducer = (state, action) => {
  const { allItems } = action;
  switch (action.type) {
    case 'addNewItem':
      if (isEmpty(action?.chart)) return state;
      let updatedItems = allItems.filter((el) => el.i !== '__droppingItem__');
      updatedItems = state.map((el) => {
        const elementWithUpdatedPosition = updatedItems.find(
          (l) => l.i === el.i
        );
        return {
          ...el,
          x: elementWithUpdatedPosition.x,
          y: elementWithUpdatedPosition.y,
          h: elementWithUpdatedPosition.h,
          w: elementWithUpdatedPosition.w
        };
      });
      return [
        ...updatedItems,
        {
          x: action.layout.x,
          y: action.layout.y,
          w: 6,
          h: 10,
          i: `${nanoid()}`,
          minW: 2,
          minH: 4,
          parent: '',
          chart: action.chart,
          chartOptions: action.chartOptions
        }
      ];
    case 'updateLayout':
      return action.layout;
    default:
      return state;
  }
};

export default layoutReducer;
